<template>
  <a-drawer
    :closable="true"
    :maskClosable="true"
    :title="title"
    :visible="visible"
    @close="close"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    width="650"
  >
    <a-form>
      <a-form-item label="所拥有的权限">
        <a-tree
          :checkedKeys="checkedKeys"
          :checkStrictly="checkStrictly"
          :expandedKeys="expandedKeysss"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          @check="onCheck"
          @expand="onExpand"
          @select="onTreeNodeSelect"
          checkable
        >
          <span slot="hasDatarule" slot-scope="{ slotTitle, ruleFlag }">
            {{ slotTitle }}
            <a-icon style="margin-left: 5px; color: red" type="align-left" v-if="ruleFlag"></a-icon>
          </span>
        </a-tree>
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <a-dropdown :trigger="['click']" placement="topCenter" style="float: left">
        <a-menu slot="overlay">
          <a-menu-item @click="switchCheckStrictly(1)" key="1">父子关联</a-menu-item>
          <a-menu-item @click="switchCheckStrictly(2)" key="2">取消关联</a-menu-item>
          <a-menu-item @click="checkALL" key="3">全部勾选</a-menu-item>
          <a-menu-item @click="cancelCheckALL" key="4">取消全选</a-menu-item>
          <a-menu-item @click="expandAll" key="5">展开所有</a-menu-item>
          <a-menu-item @click="closeAll" key="6">合并所有</a-menu-item>
        </a-menu>
        <a-button>
          树操作
          <a-icon type="up" />
        </a-button>
      </a-dropdown>
      <a-popconfirm @confirm="close" cancelText="取消" okText="确定" title="确定放弃编辑？">
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button :loading="loading" @click="handleSubmit(false)" ghost style="margin-right: 0.8rem" type="primary">仅保存</a-button>
      <a-button :loading="loading" @click="handleSubmit(true)" type="primary">保存并关闭</a-button>
    </div>

    <role-datarule-modal ref="datarule"></role-datarule-modal>
  </a-drawer>
</template>
<script>
  import { queryTreeListForRole } from '@/api/api'
  import { getAction, postAction } from '@/api/manage'
  import RoleDataruleModal from './RoleDataruleModal.vue'

  export default {
    name: 'TenantAuthModal',
    components: {
      RoleDataruleModal
    },
    data () {
      return {
        tenantId: '',
        treeData: [],
        defaultCheckedKeys: [],
        checkedKeys: [],
        expandedKeysss: [],
        allTreeKeys: [],
        autoExpandParent: true,
        checkStrictly: true,
        title: '租户菜单配置',
        visible: false,
        loading: false,
        selectedKeys: [],
        url: {
          queryTenantPermission: '/sys/permission/queryTenantPermission',
          saveTenantPermission: '/sys/permission/saveTenantPermission'
        }
      }
    },
    methods: {
      onTreeNodeSelect (id) {
        if (id && id.length > 0) {
          this.selectedKeys = id
        }
        this.$refs.datarule.show(this.selectedKeys[0], this.tenantId)
      },
      onCheck (o) {
        if (this.checkStrictly) {
          this.checkedKeys = o.checked
        } else {
          this.checkedKeys = o
        }
      },
      show (tenantId) {
        this.tenantId = tenantId
        this.visible = true
      },
      close () {
        this.reset()
        this.$emit('close')
        this.visible = false
      },
      onExpand (expandedKeys) {
        this.expandedKeysss = expandedKeys
        this.autoExpandParent = false
      },
      reset () {
        this.expandedKeysss = []
        this.checkedKeys = []
        this.defaultCheckedKeys = []
        this.loading = false
      },
      expandAll () {
        this.expandedKeysss = this.allTreeKeys
      },
      closeAll () {
        this.expandedKeysss = []
      },
      checkALL () {
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if (v == 1) {
          this.checkStrictly = false
        } else if (v == 2) {
          this.checkStrictly = true
        }
      },
      handleCancel () {
        this.close()
      },
      handleSubmit (exit) {
        // for (let index = 0; index < this.defaultCheckedKeys.length; index++) {
        //   const hadMenu = this.defaultCheckedKeys[index]
        //   if (!this.checkedKeys.includes(hadMenu)) {
        //     this.confirm()
        //   }
        // }

        let that = this
        let params = {
          tenantId: that.tenantId,
          permissionIds: that.checkedKeys.join(','),
          lastpermissionIds: that.defaultCheckedKeys.join(',')
        }

        that.loading = true
        console.log('请求参数：', params)
        postAction(this.url.saveTenantPermission, params).then((res) => {
          that.loading = false
          if (res.success) {
            that.$message.success(res.message)
            if (exit) {
              that.close()
            }
          } else {
            that.$message.error(res.message)
            if (exit) {
              that.close()
            }
          }
          this.loadData()
        })
      },
      loadData () {
        queryTreeListForRole().then((res) => {
          this.treeData = res.result.treeList
          this.allTreeKeys = res.result.ids
          getAction(this.url.queryTenantPermission, { tenantId: this.tenantId }).then((res) => {
            this.checkedKeys = [...res.result]
            this.defaultCheckedKeys = [...res.result]
            this.expandedKeysss = this.allTreeKeys
          })
        })
      }
    },
    watch: {
      visible () {
        if (this.visible) {
          this.loadData()
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>
